<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-10 14:20:04
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 15:51:24
-->
<template>
  <ux-form
    class="bind-access x-padding-x"
    ref="form"
    :colon="true"
    :data="formData"
    :rules="rules"
    label-width="80px"
    data-automation="bindAccess"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.apiStepOne.name')" prop="groupId">{{ data.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.router.access')" prop="policy">
      <ux-select
        v-model="formData.policy"
        :options="accessList"
        :props="{ label: 'name', value: 'id' }"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addAccessApi.evn')" prop="env">
      <ux-select v-model="formData.env" :options="$opt.env2"></ux-select>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, // api-id
        policy: '', // 访问策略id
        env: '' // 环境
      },
      rules: {},
      accessList: []
    };
  },

  created() {
    this.getList();
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.access.getList(params).then((res) => {
        if (res.code == 10000) {
          this.accessList = res.data;
        }
      });
    },

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
